const state = {
  users: {}
}

export default state


